import classnames from 'classnames';
import * as React from 'react';
import { paragraph, size } from './paragraph.css.js';

/**
 * Renders a longer text with specified typographic styles.
 */
const Paragraph = ({ size: size$1 = 'medium', className, ...rest }) => (React.createElement("p", { className: classnames(paragraph, size[size$1], className), ...rest }));

export { Paragraph };
